import React from 'react'
import Slider from 'react-slick'
import Part_1 from '../../../assets/images/partners/01.png'
import Part_2 from '../../../assets/images/partners/02.png'
import Part_3 from '../../../assets/images/partners/03.png'
import Part_4 from '../../../assets/images/partners/04.png'

const Part = {
    slidesToShow: 5,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
            }
        },
        {
            breakpoint: 740,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
            }
        }
    ]
}

const Partner = () => {
    return (
        <>
            <div id="partners" className="partners-main-block">
                <div className="container">
                    <Slider className="slider partners-autoplay" {...Part}>
                        <div className="partners-img">
                            <img src={Part_1} className="img-fluid" alt="" />
                        </div>
                        <div className="partners-img">
                            <img src={Part_2} className="img-fluid" alt="" />
                        </div>
                        <div className="partners-img">
                            <img src={Part_3} className="img-fluid" alt="" />
                        </div>
                        <div className="partners-img">
                            <img src={Part_4} className="img-fluid" alt="" />
                        </div>
                        <div className="partners-img">
                            <img src={Part_1} className="img-fluid" alt="" />
                        </div>
                        <div className="partners-img">
                            <img src={Part_2} className="img-fluid" alt="" />
                        </div>
                        <div className="partners-img">
                            <img src={Part_3} className="img-fluid" alt="" />
                        </div>
                        <div className="partners-img">
                            <img src={Part_4} className="img-fluid" alt="" />
                        </div>
                    </Slider>
                </div>
            </div>

        </>
    )
}

export default Partner
